const VIEW_POLL_GROUPS = Object.freeze({
  positions: new Set(["overview", "chart", "positions"]),
  signals: new Set(["overview", "signals", "all_logs"]),
  trades: new Set(["overview", "positions", "research", "activity", "all_logs"]),
  logs: new Set(["overview", "activity", "all_logs"]),
  performance: new Set(["overview", "positions"]),
  research: new Set(["research"]),
  orders: new Set(["overview", "all_logs"]),
});

export const ACCOUNT_POLL_INTERVALS = Object.freeze({
  fallbackRealtime: 5000,
  streamBackup: 60000,
  signals: 10000,
  trades: 15000,
  logs: 5000,
  performance: 30000,
  orders: 15000,
});

export function shouldPollViewData(group, activeView) {
  return VIEW_POLL_GROUPS[group]?.has(activeView) || false;
}

